import { render, staticRenderFns } from "./PageChargeBaoHistory.vue?vue&type=template&id=f9804d2c"
import script from "./PageChargeBaoHistory.vue?vue&type=script&lang=js"
export * from "./PageChargeBaoHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports